import clsx from 'clsx'
import type { BookUniverse } from '@/types/dashboards'

interface BookUniverseLineProps {
  universe: BookUniverse | null | undefined
  className?: string
}

/** One line stating the deal set a board counts — what is in, what is
 *  excluded (dead, archived) and how much is illustrative seed data — so the
 *  same book never reads as 37, 38 and 39 deals with nothing saying why. */
export default function BookUniverseLine({ universe, className }: BookUniverseLineProps) {
  if (!universe) return null
  return (
    <p
      className={clsx('font-mono text-[10px] leading-snug text-stone-500', className)}
      data-testid="book-universe"
    >
      <span className="text-stone-400">Book counted:</span> {universe.statement}
    </p>
  )
}
